import Vue from 'vue'
import App from './App.vue'
import router from "./router/index.js" //引入你新建的router文件
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

import "./assets/aliiconfont/iconfont.css"

Vue.config.productionTip = false
Vue.use(vueSwiper)

new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
